// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Production20CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Production20CircleFilled: FC<Production20CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M14.985 12c0 1.657-1.336 3-2.985 3a2.993 2.993 0 0 1-2.985-3c0-1.657 1.336-3 2.985-3a2.993 2.993 0 0 1 2.985 3Z" />
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm-2.323-6.677a.406.406 0 0 0-.234-.312 2.76 2.76 0 0 1-.25-.136 6.03 6.03 0 0 1-.247-.159.389.389 0 0 0-.37-.04l-1.718.726a.375.375 0 0 1-.471-.158l-1.722-2.99a.375.375 0 0 1 .097-.485l1.485-1.13a.426.426 0 0 0 .156-.352V11.713a.426.426 0 0 0-.156-.352l-1.485-1.13a.375.375 0 0 1-.097-.486l1.722-2.989a.375.375 0 0 1 .47-.158l1.72.726c.121.05.26.034.37-.04a5.148 5.148 0 0 1 .505-.294.4.4 0 0 0 .224-.306l.23-1.855a.375.375 0 0 1 .373-.329h3.442c.19 0 .349.141.372.329l.23 1.848a.406.406 0 0 0 .234.312c.086.041.17.087.25.136.084.05.166.104.247.159a.389.389 0 0 0 .37.04l1.718-.726a.375.375 0 0 1 .471.158l1.722 2.99a.375.375 0 0 1-.098.485l-1.483 1.13a.426.426 0 0 0-.157.352v.54c0 .154.043.315.166.408l1.456 1.108c.15.114.192.322.098.486l-1.722 2.988a.375.375 0 0 1-.472.158l-1.7-.724a.392.392 0 0 0-.37.039 5.113 5.113 0 0 1-.505.294.4.4 0 0 0-.224.306l-.23 1.855a.375.375 0 0 1-.373.329h-3.442a.375.375 0 0 1-.372-.329l-.23-1.848Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Production20CircleFilled;
